import React, { FC } from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';
import { font as initialFont } from '@styles/fonts';
import { useOperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper/hooks';
import { OPERATOR_PANEL_PADDING } from '@components/operatorPanel/constants/operatorPanel.constants';

export interface TitleProps {
  text: string;
  fontType?: keyof typeof initialFont;
  color?: string;
}

const Title: FC<TitleProps> = ({ text, fontType = 'Title 2', color = 'Label/Light/Primary' }) => {
  const { C, font, scale } = useOperatorPanelSettingsWrapperContext();

  return (
    <View
      style={{
        position: 'absolute',
        left: scale(OPERATOR_PANEL_PADDING),
        right: scale(OPERATOR_PANEL_PADDING),
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text style={[font[fontType], { color: C(color), textAlign: 'center' }]}>{i18n.t(text)}</Text>
    </View>
  );
};

export default Title;
